// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pop-over-items .MuiTypography-root {
  color: var(--character-title-85, rgba(0, 0, 0, 0.85));
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.05px;
}

.disabled-item {
  opacity: 0.38;
  cursor: default;
}

.disabled-item:hover {
  background: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/moreOptionsPopOver/moreOptionsPopOver.css"],"names":[],"mappings":"AAAA;EACE,qDAAqD;EACrD,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".pop-over-items .MuiTypography-root {\n  color: var(--character-title-85, rgba(0, 0, 0, 0.85));\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.05px;\n}\n\n.disabled-item {\n  opacity: 0.38;\n  cursor: default;\n}\n\n.disabled-item:hover {\n  background: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
